import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-format-strikethrough",
  templateUrl: "./med-icon-format-strikethrough.component.html",
})
export class MedIconFormatStrikethroughComponent extends SvgMixinComponent {}
